import {
  VpnServers,
  PowerSchedules,
  PowerTypes,
  RouterStatuses,
} from "@/components/constants.js"

const battery = [
  { name: "All", value: "" },
  { name: "Has Battery", value: true },
  { name: "No Battery", value: false },
]

export default (self) => {
  return {
    routerType: {
      component: "SelectSearchFilter",
      attributes: {
        items: [
          { value: "", name: "All" },
          ...self.routerTypes.map((value) => ({ value, name: value })),
        ],
      },
    },
    vpnServer: {
      component: "SelectSearchFilter",
      attributes: {
        items: [{ value: "", name: "All" }, ...VpnServers],
      },
    },
    serialNumber: {
      component: "TextFieldSearchFilter",
    },
    kitSerial: {
      component: "TextFieldSearchFilter",
    },
    kitName: {
      component: "TextFieldSearchFilter",
    },
    billPayers: {
      component: "SelectSearchFilter",
      attributes: {
        items: [
          { value: "", name: "All" },
          ...self.billPayers.map((value) => ({ value, name: value })),
        ],
      },
    },
    sims: {
      component: "TextFieldSearchFilter",
    },
    lastSms: {
      component: "TextFieldSearchFilter",
    },
    lastSmsAt: {
      component: "DatePickerSearchFilter",
      attributes: {
        textFieldAttrs: {
          placeholder: "Deliver At",
        },
        convertToIso: false,
      },
    },
    lastSeen: {
      name: "hasBattery",
      component: "SelectSearchFilter",
      attributes: {
        items: battery,
      },
    },
    status: {
      component: "SelectSearchFilter",
      attributes: {
        items: [{ value: "", name: "All" }, ...RouterStatuses],
      },
    },
    powerType: {
      component: "SelectSearchFilter",
      attributes: {
        items: [{ value: "", name: "All" }, ...PowerTypes],
      },
    },
    powerSchedule: {
      component: "SelectSearchFilter",
      attributes: {
        items: [{ value: "", name: "All" }, ...PowerSchedules],
      },
    },
    routerHttpPort: {
      component: "TextFieldSearchFilter",
    },
  }
}
